module.exports = __webpack_public_path__ + "img/icomoon.138acfb.svg";